import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CountDownComponent } from '../session-timeout/count-down/count-down.component';
import { CountDownOptions } from '../session-timeout/count-down/models/count-down-options';
import { DialogUnlockFolderRequestData } from './models/dialog-unlock-folder-request-data';

@Component({
    selector: 'app-unlock-folder-request',
    templateUrl: './unlock-folder-request.component.html',
    styleUrls: ['./unlock-folder-request.component.scss'],
    imports: [MatCardModule, CountDownComponent, MatButtonModule]
})
export class UnlockFolderRequestComponent {
    /**
     * Options du compteur.
     */
    public countDownOptions = new CountDownOptions(false, false, true, true);

    private acceptUnlockFolder: boolean = false;

    public timeOutDate: Date;

    /**
     * Constructeur.
     * @param dialogRef
     */
    constructor(
        public dialogRef: MatDialogRef<UnlockFolderRequestComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogUnlockFolderRequestData
    ) {
        // Calcul la date de fin du délai de réponse
        this.timeOutDate = new Date(Date.now());
        this.timeOutDate.setSeconds(this.timeOutDate.getSeconds() + data.delay);

        this.dialogRef.beforeClosed().subscribe((x) => {
            this.dialogRef.close(this.acceptUnlockFolder);
        });
    }

    /**
     * Appelée lorsque l'utilisateur clique sur le bouton 'Non'.
     */
    public close(): void {
        this.acceptUnlockFolder = false;
        this.dialogRef.close();
    }

    /**
     * Appelée lorsque l'utilisateur clique sur le bouton 'Oui'.
     */
    public valid(): void {
        this.acceptUnlockFolder = true;
        this.dialogRef.close();
    }

    onFinished() {
        this.acceptUnlockFolder = true;
        this.dialogRef.close();
    }
}
